// Детерминированный ГПСЧ с seed — для воспроизводимости матча.
// Алгоритм mulberry32: быстрый, без зависимостей, для игры более чем достаточно.

export function createRng(seed) {
  let s = seed >>> 0;
  function next() {
    s = (s + 0x6D2B79F5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), 1 | t);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  return {
    seed,
    // [0, 1)
    next,
    // Целое в [0, n)
    int(n) {
      return Math.floor(next() * n);
    },
    // Случайный элемент массива (или undefined для пустого).
    pick(arr) {
      if (!arr || arr.length === 0) return undefined;
      return arr[Math.floor(next() * arr.length)];
    },
    // Тасует массив на месте (Фишер-Йетс) и возвращает его же.
    shuffle(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(next() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    }
  };
}
